import React from 'react';
import { useEffect, useState } from 'react';
export const markerComponentIsPropsEqual = (prev, next) => {
  var _a;
  const messageKeysList = Object.keys((prev === null || prev === void 0 ? void 0 : prev.message) || {});
  const sameMessage = messageKeysList.every(key => {
    return (prev === null || prev === void 0 ? void 0 : prev.message[key]) === (next === null || next === void 0 ? void 0 : next.message[key]);
  });
  const markerComponentPropsKeysList = Object.keys(((_a = prev === null || prev === void 0 ? void 0 : prev.message) === null || _a === void 0 ? void 0 : _a.markerComponentProps) || {});
  const sameMarkerComponentProps = markerComponentPropsKeysList.every(key => {
    var _a, _b;
    return ((_a = prev === null || prev === void 0 ? void 0 : prev.message) === null || _a === void 0 ? void 0 : _a.markerComponentProps[key]) === ((_b = next === null || next === void 0 ? void 0 : next.message) === null || _b === void 0 ? void 0 : _b.markerComponentProps[key]);
  });
  return sameMessage && sameMarkerComponentProps;
};
export const useMarkerComponentMemo = markerComponents => {
  const [memoMarkerComponents, setMemoMarkerComponents] = useState({});
  const componentCount = Object.keys(markerComponents || {}).length;
  useEffect(() => {
    if (!markerComponents || typeof markerComponents !== 'object') return;
    const memoList = {};
    Object.keys(markerComponents).forEach(key => {
      const component = markerComponents[key];
      if (typeof component === 'function') {
        memoList[key] = React.memo(component, markerComponentIsPropsEqual);
      }
    });
    setMemoMarkerComponents(memoList);
  }, [componentCount]);
  return memoMarkerComponents;
};